







































































import { Vue, Component, Prop } from "vue-property-decorator";
import NoBusinesses from "@/modules/businesses/components/NoBusinesses.vue";
import { namespace } from "vuex-class";

const Businesses = namespace("business");
const Applicants = namespace("applicant");

@Component({
  components: {
    "no-businesses": NoBusinesses,
  },
})
export default class EmptyTable extends Vue {
  @Prop({ default: "You haven’t created your first applicant yet" })
  readonly title!: string;
  @Prop({
    default: `Learn how to set up the Orba One SDK with your web or mobile application with our quick start guide.`,
  })
  readonly subtitle!: string;
  @Prop({ default: false }) readonly isBusiness!: boolean;
  @Businesses.Getter("query") businessesQuery: string;
  @Applicants.Getter("query") applicantsQuery: string;

  isSearchResult = false;
  mounted() {
    // Checks to see if this component is being shown as a result of a search
    this.isSearchResult = this.isBusiness
      ? this.businessesQuery !== ""
      : this.applicantsQuery !== "";
  }
}
